import { customerApi } from "../../utils/apiConfig";

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

export const getDashboardDocumentExpirySummary = (params = {}) => {
  return customerApi.get("/dashboard/document-expiry-summary", {
    ...authHeader(),
    params: {
      warningDays: 30,
      ...params,
    },
  });
};
